<!--(13-4)教育机构收藏应聘信息-->
<template>
  <div class="main-css">
    <div class="main-box">
      <!--    标题-->
      <div class="title-css">{{ $t("collectApplicationCases") }}</div>
      <el-button type="primary" style="width: 200px" @click="deleteMore">{{
        $t("delete")
      }}</el-button>
      <!-- table部分 -->
      <div class="table">
        <el-table
          :data="tableData"
          @row-click="jump"
          style="width: 98%"
          :max-height="tableHeight"
          @sort-change="changeTableSort"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- ----------------------人材番号---------------------- -->
          <el-table-column
            prop="institutionNumber"
            label="人材番号"
            min-width="80"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="txtOver">{{ $t("talentNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.resumeId }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column
            prop="Name"
            label="氏名"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------応募案件---------------------- -->
          <el-table-column
            prop="RecruitmentName"
            label="応募案件"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseName") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.jobName }}</span>
            </template>
          </el-table-column>
          <!-- ---------------------性别-------------------- -->
          <el-table-column prop="sex" label="性别" header-align="center">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("sex") }}</p>
              <el-dropdown @command="handleCommandSex">
                <span class="el-dropdown-link">
                  {{ opSex }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in sexValue"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="null">
                    {{ "ALL" }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <div v-if="language == 'ja-JP'">
                {{ scope.row.jpsex_dictText }}
              </div>
              <div v-else>
                {{ scope.row.sex_dictText }}
              </div>
            </template>
          </el-table-column>
          <!-- ----------------------生年月日---------------------- -->
          <el-table-column prop="birth" label="生年月日" min-width="110">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("birth") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template>
            <template slot-scope="scope" v-if="scope.row.birth"
              >{{ scope.row.birth.split(" ")[0] }}
            </template>
          </el-table-column>
          <!-- ----------------------学歴---------------------- -->
          <el-table-column
            prop="education"
            min-width="110"
            label="学歴"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalBackgroundMatter") }}</p>
              <el-input
                v-model="searchData5"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template>
            <template slot-scope="scope">
              <div v-if="language == 'ja-JP'">
                {{ scope.row.jpeducation_dictText }}
              </div>
              <div v-else>
                {{ scope.row.education_dictText }}
              </div>
            </template>
          </el-table-column>
          <!-- ---------------------専攻--------------------- -->
          <el-table-column
            prop="profession"
            label="専攻"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("major") }}</p>
              <el-input
                v-model="searchData6"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template>
          </el-table-column>
          <!-- -----------------------日本語----------------------- -->
          <el-table-column
            prop="japanese"
            label="学歴"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("japaneseVs") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template>
            <template slot-scope="scope">
              <div v-if="language == 'ja-JP'">
                {{ scope.row.jpjapanese_dictText }}
              </div>
              <div v-else>
                {{ scope.row.japanese_dictText }}
              </div>
            </template>
          </el-table-column>
          <!-- ------------------------応募日------------------------ -->
          <el-table-column prop="createTime" label="応募日" min-width="110">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("fundingDayPayment") }}</p>
              <el-input
                v-model="searchData8"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template>
            <template slot-scope="scope" v-if="scope.row.createTime"
              >{{ scope.row.createTime.split(" ")[0] }}
            </template>
          </el-table-column>
          <!-- ------------------------状态------------------------ -->
          <el-table-column prop="Status" label="status" width="90">
            <!-- <template slot="header" slot-scope="scope">
              <p>{{ $t("situationId") }}</p>
              <el-input
                v-model="searchData9"
                size="mini"
                placeholder="Search"
                @change="fuzzy"
              />
            </template> -->
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <el-dropdown @command="handleCommandStatus">
                <span class="el-dropdown-link">
                  {{ opStatus
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in sexStatus"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="null">
                    {{ "ALL" }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <!-- <template slot-scope="scope">
              <div v-for="item in List">
                <span v-if="item.code == scope.row.statusName">{{
                  item.name
                }}</span>
              </div>
            </template> -->
            <template slot-scope="scope">
              <div v-if="language == 'ja-JP'">
                {{ scope.row.jpapplyStatus_dictText }}
              </div>
              <div v-else>
                {{ scope.row.applyStatus_dictText }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalItem"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ this.pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  fuzzySelectApplyJobCollect,
  deleteApplyJobCollect,
  selectApplyJobCollect
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "medicalInstitutionsCollectApplicationInformationList",
  components: {},
  data() {
    return {
      language: "",
      jorc: this.$i18n.locale,
      inputData1: "", //搜索框input内容
      tableData: [], //   table内容
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      searchData9: "",
      sex: "",
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      multipleSelection: [],
      sexValue: null,
      opSex: "All",
      totalItem: 0,
      tableHeight: "", //表格高度
      opStatus: "All",
      List: [],
      sexStatus: null
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.star();
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.selectsex();
    this.staffNumber();
    this.getTableHeight();
    this.jpstaffNumber();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    //挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //跳到12-4
    jump(row) {
      // this.$router.push({
      //   name: "educationInstitutionCaseResponderViewing",
      //   query: { applyId: row.applyId }

      // });
      this.$router.push({
        name: "detailsOfApplicantsForCasesInEducationalInstitutions",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    //获取下拉框选项
    jpstaffNumber() {
      var that = this;
      // that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem:
              this.language !== "ja-JP" ? "applyStatus" : "jpapplyStatus"
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.sexStatus = aesFecInfo.data;
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //获取数据字典
    staffNumber() {
      var that = this;
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem:
              this.language !== "ja-JP" ? "applyStatus" : "jpapplyStatus"
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.List = aesFecInfo.data;
            console.log(that.List);
          } else {
            console.log(res.data);
            console.log("ccj");
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    handleCommandStatus(e) {
      console.log(e);
      if (e == null) {
        this.searchData9 = null;
        this.opStatus = "";
        console.log(e);
      } else {
        this.searchData9 = e.code;
        this.opStatus = e.name;
      }
      this.fuzzy();
    },
    //获取表格高度
    getTableHeight() {
      let tableH = 310; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },

    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据7------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        this.staffNumber();
        this.jpstaffNumber();
        that.star();
        this.searchDataStart = this.$route.query.searchData;
        console.log(this.searchDataStart);
        that.selectsex();
      }
    },
    //性别筛选
    handleCommandSex(e) {
      console.log(e);
      if (e == null) {
        this.sex = "";
        this.opSex = "ALL";
        console.log(e);
      } else {
        this.sex = e.code;
        this.opSex = e.name;
      }
      console.log(this.sex);
      this.fuzzy();
    },
    //下拉框选项
    selectsex() {
      var that = this;
      var dataItem = "";
      if (that.language === "ja-JP") {
        dataItem = "jpsex";
      } else {
        dataItem = "sex";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItem
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.sexValue = aesFecInfo.data;
            console.log(that.sexValue);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = [];
      for (var i = 0; i < val.length; i++) {
        this.multipleSelection.push(val[i].collectId);
      }
      console.log(this.multipleSelection);
    },
    //批量删除
    deleteMore() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择想要删除的用户",
          type: "warning"
        });
      } else {
        var medicalCollectId = {
          collectId: this.multipleSelection
        };
        deleteApplyJobCollect(medicalCollectId)
          .then(res => {
            console.log("批量删除", res);
            if (res.data.code === "A0000") {
              this.$message.error("批量删除成功");
              this.star();
            } else {
              this.$message.error("批量删除失败");
            }
          })
          .catch(res => {
            console.log("删除失败", res);
          });
      }
    },
    //模糊查询
    fuzzy() {
      var dto = {
        applyStatus: this.searchData9,
        avatar: "",
        birth: this.searchData4,
        createTime: this.searchData8,
        education: this.searchData5,
        japanese: this.searchData7,
        statusName: this.searchData9,
        jobName: this.searchData3,
        name: this.searchData2,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        profession: this.searchData6,
        resumeId: this.searchData1,
        sex: this.sex
      };
      fuzzySelectApplyJobCollect(dto)
        .then(res => {
          console.log("医疗机构招聘表模糊查询:", res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.tableData = aesFecInfo.data;
            console.log(aesFecInfo.data);
          } else {
            console.log(dto);
            this.$message.error("查询失败");
          }
        })
        .catch(res => {
          console.log("医疗机构招聘表模糊查询失败:", res);
        });
    },
    //获取数据
    star() {
      var dto = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      selectApplyJobCollect(dto)
        .then(res => {
          console.log("医疗机构招聘表:", res);
          if (res.data.code === "A0000") {
            console.log(dto);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("aesFecInfo,aesFecInfo", aesFecInfo.data);
            this.tableData = aesFecInfo.data.map(item => {
              item.birth = item.birth ? item.birth.split(" ")[0] : "";
              item.createTime = item.createTime
                ? item.createTime.split(" ")[0]
                : "";
              return item;
            });
            this.totalItem = aesFecInfo.total;
          } else {
            console.log(dto);
            this.$message.error("查询失败");
          }
        })
        .catch(res => {
          console.log("医疗机构招聘表错误", res);
        });
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "Japaneselevel") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["Japaneselevel"] - b["Japaneselevel"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["Japaneselevel"] - a["Japaneselevel"]
          );
        }
      } else {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["recruitmentDate"] - b["recruitmentDate"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["recruitmentDate"] - a["recruitmentDate"]
          );
        }
      }
    },
    //
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(this.currentPage);
      this.star();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        this.star();
      } else if (command === "b") {
        this.pageSize = 15;
        this.star();
      } else if (command === "c") {
        this.pageSize = 20;
        this.star();
      } else if (command === "d") {
        this.pageSize = 25;
        this.star();
      }
    },
    // 员工申请
    staffApplicationHandleAdd(row) {
      this.$router.push({
        path: "/advancedCertification",
        query: { rowData: row, role: 0 }
      });
    },
    //管理员申请
    managerApplicationHandleAdd(row) {
      this.$router.push({
        path: "/advancedCertification",
        query: { rowData: row, role: 1 }
      });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
}

.main-box {
  margin-top: 10px;
  width: 100%;
  height: 99%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  margin-top: 20px;
  height: auto;
  width: 100%;
  max-height: calc(100% - 1.4rem);
  overflow-y: auto;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
}

.operate {
  height: 48px;
}

.table /deep/ .el-dropdown {
  width: 100px;
}

.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: 0;
  width: 67px;
}

.table /deep/ .element.style {
  width: 95%;
  height: 580px;
}

.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}

.pagination-main {
  float: right;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.form-button button {
  height: 40px;
  line-height: 40px;
  width: 150px;
  background: #fc630c;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #6b5656; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 4; /*行间距*/
}
</style>



// WEBPACK FOOTER //
// src/pages/educationalInstitutionsCollectApplicationInformationList/index.vue